import { render, staticRenderFns } from "./PerformanceTrackingItems.vue?vue&type=template&id=33b48d46&scoped=true"
import script from "./PerformanceTrackingItems.vue?vue&type=script&lang=js"
export * from "./PerformanceTrackingItems.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTrackingItems.vue?vue&type=style&index=0&id=33b48d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b48d46",
  null
  
)

export default component.exports